<template>
    <div class="modal fade" id="confirmationRejectionModal" role="dialog" aria-labelledby="confirmationRejectionModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="confirmationRejectionModalLabel">{{$t('buttons.confirmationRejectionDetails.btnText')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <table class="table table-responsive">
                        <tbody>
                            <tr>
                                <td>{{ $t('confirmationRejection.note') }}</td>
                                <td>{{ model.note }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('confirmationRejection.rejectedByAdmin') }}</td>
                                <td>
                                    <span v-if="model.rejectedByAdmin" class="badge badge-danger">{{ $t('yes') }}</span>
                                    <span class="badge badge-secondary">{{ $t('no') }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('confirmationRejection.user') }}</td>
                                <td>{{ model.user }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('confirmationRejection.time') }}</td>
                                <td>{{ model.timeUtc ? $moment(timeUtc).format('DD.MM.YYYY HH:mm') : '' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ConfirmationRejectionDetailsModel } from '@/models/models';
    import tempRankingService from '@/services/tempRanking.service';

    export default {
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                showDetails: false,
                model: new ConfirmationRejectionDetailsModel(),
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = new ConfirmationRejectionDetailsModel();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onCancel() {
                this.onClose();
            },
            loadRankingConfirmationDeatils(id) {
                return new Promise((resolve, reject) => {
                    if (!id) {
                        // eslint-disable-next-line prefer-promise-reject-errors
                        reject();
                    }

                    tempRankingService.getConfirmationRejectionDetails(id)
                        .then(response => {
                            resolve(response.data)
                        })
                        .catch(error => {
                            reject(error)
                        });
                });
            }
        },
        mounted() {
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.loadRankingConfirmationDeatils(this.value.id)
                        .then(data => {
                            this.model = new ConfirmationRejectionDetailsModel(data);
                        }).catch(error => {
                            // skip
                        }).then(() => { this.showDetails = true });
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
